import { Position } from "geojson";

export enum PortalLineSegmentType {
    ARC_BY_EDGE = "ArcByEdge",
    ARC_BY_ANGLES = "ArcByAngles",
    FOLLOWS_GEO_BORDER = "FollowsGeoBorder",
    GREAT_CIRCLE = "GreatCircle",
}

export interface PortalVertex {
    index: number;
    point: Position;
}

export interface PortalLineSegment<VertexType extends PortalVertex = PortalVertex> {
    type: PortalLineSegmentType;
    properties: VertexType;
}

export interface PortalArcByEdge extends PortalVertex {
    arcPoint: Position;
}

export interface PortalArcByAngles extends PortalVertex {
    center: Position;
    radius: number;
    bearing1: number;
    bearing2: number;
}

export interface PortalFollowsGeoBorder extends PortalVertex {
    geoBorderId: string;
}

export interface PortalGreatCircle extends PortalVertex {}
